import { render, staticRenderFns } from "./ResetPwd.vue?vue&type=template&id=2e204dc4&scoped=true&"
import script from "./ResetPwd.vue?vue&type=script&lang=js&"
export * from "./ResetPwd.vue?vue&type=script&lang=js&"
import style0 from "./ResetPwd.vue?vue&type=style&index=0&id=2e204dc4&lang=scss&scoped=true&"
import style1 from "./ResetPwd.vue?vue&type=style&index=1&id=2e204dc4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e204dc4",
  null
  
)

export default component.exports